import { apiUrl } from 'config';
import axios from '../_helpers/axios';

export const refsService = {
  getAll,
  newItem,
  archiveClient,
  updateItem,
};

function getAll() {
  return axios.get(`${apiUrl}/api/refs/all?except[]=links`);
}

function newItem(data) {
  const requestOptions = {
    refName: data.refName,
    refData: data.refData,
  };
  return axios.post(`${apiUrl}/api/refs/new`, requestOptions);
}

function updateItem(data) {
  const requestOptions = {
    refName: data.refName,
    refData: data.refData,
  };
  return axios.post(`${apiUrl}/api/refs/save`, requestOptions);
}

async function archiveClient(data) {
  return await axios
    .post(`${apiUrl}/api/refs/archiveClient`, {id:data.clientToArchive.id,archiveAction:data.archiveAction})
    .then(response => {
      return Object.assign(response,{clientData:data});
    });


}
